import { useLingui } from "@lingui/react/macro";

import React, { useCallback } from "react";
import {
  Slider as BaseSlider,
  SliderSlide as BaseSliderSlide,
  SliderProps
} from "@silversea-ssc/ui-components-react";
import { dispatchTrackingEvent } from "src/utils/analytics";
import { LinguiT } from "src/utils/localization/lingui-helpers";
import { msg } from "@lingui/core/macro";

export const sliderLabels = (t: LinguiT) => ({
  goToPage: t(msg`Go to page`),
  previous: t(msg`Previous`),
  next: t(msg`Next`),
  counterSeparator: t(msg`count-separator-xx-of-xx`)
});

const Slider: React.FC<React.PropsWithChildren<SliderProps>> = ({
  children,
  ...props
}) => {
  const { t } = useLingui();
  const labels = sliderLabels(t);

  const onSlideChange = useCallback((slideNumber: number) => {
    dispatchTrackingEvent("slider_slide_changed", {
      value: slideNumber
    });
  }, []);

  return (
    <BaseSlider
      {...props}
      labels={labels}
      onSlideChange={onSlideChange}
      suppressHydrationWarning
    >
      {children}
    </BaseSlider>
  );
};

const SliderSlide = BaseSliderSlide;
export { SliderSlide };
export default Slider;
